import API from '../api';

export const startComputerGame = (payload) =>
  API.post('/playing/games/computer', payload).then((r) => r.data);

export const getMyGames = (page, size) =>
  API.get('/playing/games/mine', {
    params: page != null || size != null
      ? { page: page ?? 0, size: size ?? 50 }
      : undefined,
  }).then((r) => r.data);

/** Staff: games for any user (coach desk). */
export const getStaffUserGames = (userId, page = 0, size = 20) =>
  API.get(`/playing/games/user/${userId}`, { params: { page, size } }).then((r) => r.data);

/** Staff: playing peek (profile + live). */
export const getStaffPlayingPeek = (userId) =>
  API.get(`/playing/players/${userId}/peek`).then((r) => r.data);

export const getFairPlayModerationSummary = () =>
  API.get('/playing/fair-play/moderation-summary').then((r) => r.data);

export const getChessGame = (id) =>
  API.get(`/playing/games/${id}`).then((r) => r.data);

/** Lightweight poll: fen/clocks/status + lastMove (no full history). */
export const getChessGameState = (id) =>
  API.get(`/playing/games/${id}/state`).then((r) => r.data);

export const postChessMove = (id, payload) =>
  API.post(`/playing/games/${id}/move`, payload).then((r) => r.data);

export const resignChessGame = (id) =>
  API.post(`/playing/games/${id}/resign`).then((r) => r.data);

export const offerDraw = (id) =>
  API.post(`/playing/games/${id}/draw`).then((r) => r.data);

export const claimDraw = (id) =>
  API.post(`/playing/games/${id}/draw/claim`).then((r) => r.data);

export const declineDraw = (id) =>
  API.post(`/playing/games/${id}/draw/decline`).then((r) => r.data);

export const abortChessGame = (id) =>
  API.post(`/playing/games/${id}/abort`).then((r) => r.data);

export const claimTimeout = (id) =>
  API.post(`/playing/games/${id}/timeout`).then((r) => r.data);

export const staffAdjudicateGame = (id, result) =>
  API.post(`/playing/games/${id}/staff-result`, { result }).then((r) => r.data);

export const spectateGame = (id) =>
  API.get(`/playing/games/${id}/spectate`).then((r) => r.data);

export const getLiveGames = () =>
  API.get('/playing/games/live').then((r) => r.data);

export const getMyChessRating = (speedClass) =>
  API.get('/playing/ratings/me', {
    params: speedClass ? { speedClass } : undefined,
  }).then((r) => r.data);

export const getMyChessRatings = () =>
  API.get('/playing/ratings/me/all').then((r) => r.data);

export const getChessLeaderboard = (speedClass) =>
  API.get('/playing/ratings/leaderboard', {
    params: speedClass ? { speedClass } : undefined,
  }).then((r) => r.data);

export const getChessPlayerProfile = (userId) =>
  API.get(`/playing/players/${userId}/profile`).then((r) => r.data);

export const searchChessPlayers = (q, speedClass) =>
  API.get('/playing/players', {
    params: {
      q,
      ...(speedClass ? { speedClass } : {}),
    },
  }).then((r) => r.data);

export const getIncomingChallenges = () =>
  API.get('/playing/challenges/incoming').then((r) => r.data);

export const getOutgoingChallenges = () =>
  API.get('/playing/challenges/outgoing').then((r) => r.data);

export const createChallenge = (payload) =>
  API.post('/playing/challenges', payload).then((r) => r.data);

export const acceptChallenge = (id) =>
  API.post(`/playing/challenges/${id}/accept`).then((r) => r.data);

export const declineChallenge = (id) =>
  API.post(`/playing/challenges/${id}/decline`).then((r) => r.data);

export const cancelChallenge = (id) =>
  API.post(`/playing/challenges/${id}/cancel`).then((r) => r.data);

export const rematchGame = (id) =>
  API.post(`/playing/games/${id}/rematch`).then((r) => r.data);

export const offerTakeback = (id) =>
  API.post(`/playing/games/${id}/takeback`).then((r) => r.data);

export const declineTakeback = (id) =>
  API.post(`/playing/games/${id}/takeback/decline`).then((r) => r.data);

export const listOpenSeeks = () =>
  API.get('/playing/seeks').then((r) => r.data);

export const createSeek = (payload) =>
  API.post('/playing/seeks', payload).then((r) => r.data);

export const acceptSeek = (id, payload = {}) =>
  API.post(`/playing/seeks/${id}/accept`, payload).then((r) => r.data);

export const cancelSeek = (id) =>
  API.post(`/playing/seeks/${id}/cancel`).then((r) => r.data);

export const getChessChat = (id) =>
  API.get(`/playing/games/${id}/chat`).then((r) => r.data);

export const postChessChat = (id, message) =>
  API.post(`/playing/games/${id}/chat`, { message }).then((r) => r.data);

export const getFairPlayQueue = (params = {}) =>
  API.get('/playing/fair-play/games', { params }).then((r) => r.data);

export const getFairPlayGame = (id) =>
  API.get(`/playing/fair-play/games/${id}`).then((r) => r.data);

export const runFairPlayEngineReview = (id) =>
  API.post(`/playing/fair-play/games/${id}/engine-review`).then((r) => r.data);

export const addFairPlayNote = (id, payload) =>
  API.post(`/playing/fair-play/games/${id}/notes`, payload).then((r) => r.data);

export const upsertFairPlayCase = (id, payload) =>
  API.post(`/playing/fair-play/games/${id}/cases`, payload).then((r) => r.data);

export const listPlayBans = (params = {}) =>
  API.get('/playing/fair-play/bans', { params }).then((r) => r.data);

export const createPlayBan = (payload) =>
  API.post('/playing/fair-play/bans', payload).then((r) => r.data);

export const liftPlayBan = (banId) =>
  API.post(`/playing/fair-play/bans/${banId}/lift`).then((r) => r.data);

export const getMyPlayBanStatus = () =>
  API.get('/playing/fair-play/me/ban-status').then((r) => r.data);

export const reportChessPlayer = (payload) =>
  API.post('/playing/fair-play/reports', payload).then((r) => r.data);

export const listOpenChessReports = () =>
  API.get('/playing/fair-play/reports').then((r) => r.data);

export const resolveChessReport = (id, status = 'RESOLVED') =>
  API.post(`/playing/fair-play/reports/${id}/resolve`, { status }).then((r) => r.data);

export const appealChessBan = (message) =>
  API.post('/playing/fair-play/appeals', { message }).then((r) => r.data);

export const listOpenChessAppeals = () =>
  API.get('/playing/fair-play/appeals').then((r) => r.data);

export const resolveChessAppeal = (id, payload) =>
  API.post(`/playing/fair-play/appeals/${id}/resolve`, payload).then((r) => r.data);

export const getPlayingPrefs = () =>
  API.get('/playing/prefs').then((r) => r.data);

export const updatePlayingPrefs = (payload) =>
  API.put('/playing/prefs', payload).then((r) => r.data);

export const runCloudAnalysis = (id) =>
  API.post(`/playing/games/${id}/cloud-analysis`).then((r) => r.data);

/** Cached cloud analysis only — 404 when missing. */
export const getCachedCloudAnalysis = (id) =>
  API.get(`/playing/games/${id}/cloud-analysis`).then((r) => r.data);

export const requestClubReview = (id) =>
  API.post(`/playing/games/${id}/club-review`).then((r) => r.data);

export const shareChessAnalysis = (id, payload) =>
  API.post(`/playing/games/${id}/analysis-share`, payload).then((r) => r.data);

export const getSharedChessAnalysis = (id) =>
  API.get(`/playing/games/${id}/analysis-share`).then((r) => r.data);

/** ChessDesk Coach (LLM tutor) — status and chat. */
export const getChessCoachStatus = () =>
  API.get('/playing/coach/status').then((r) => r.data);

export const getChessCoachConversation = (gameId) =>
  API.get(`/playing/coach/games/${gameId}/messages`).then((r) => r.data);

export const clearChessCoachConversation = (gameId) =>
  API.delete(`/playing/coach/games/${gameId}/messages`).then((r) => r.data);

export const postChessCoachChat = (payload) =>
  API.post('/playing/coach/chat', payload).then((r) => r.data);

/** Provider 429/503 (surfaced as 409) — backoff retry. Do not retry app "too many questions". */
export async function postChessCoachChatWithRetry(payload, { maxAttempts = 4 } = {}) {
  let lastErr;
  for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
    try {
      return await postChessCoachChat(payload);
    } catch (e) {
      lastErr = e;
      if (!isRetryableCoachProviderError(e) || attempt >= maxAttempts) {
        throw e;
      }
      const waitMs = attempt * 2000 + Math.floor(Math.random() * 400);
      await new Promise((r) => setTimeout(r, waitMs));
    }
  }
  throw lastErr;
}

function isRetryableCoachProviderError(error) {
  const status = error?.response?.status;
  const msg = String(
    error?.response?.data?.message
    || error?.response?.data?.error
    || error?.message
    || '',
  );
  if (/too many coach questions/i.test(msg)) return false;
  if (status === 429 || status === 503) return true;
  // Backend maps provider 429 to IllegalStateException → HTTP 409
  if (status === 409 && /provider error\s*\((429|503)\)|could not reach coach ai|try again later/i.test(msg)) {
    return true;
  }
  return false;
}
